import { render, staticRenderFns } from "./CompleteBuyPoint.vue?vue&type=template&id=63368b9e&scoped=true&"
import script from "./CompleteBuyPoint.vue?vue&type=script&lang=js&"
export * from "./CompleteBuyPoint.vue?vue&type=script&lang=js&"
import style0 from "./CompleteBuyPoint.vue?vue&type=style&index=0&id=63368b9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63368b9e",
  null
  
)

export default component.exports